const CREATE_APPLICATION = "/application/create-application";
const UPLOAD_APPLICATION_LOGO = "/application/upload-application-logo";
const GET_DRIVER_APPLICATION = "/application/get-driver-application";
const GET_USER_APPLICATION = "/application/user-application";
const UPDATE_APPLICATION = "/application/upload-application-logo"; // Using the same endpoint as it handles both logo and general updates
const MARK_APPLICATION_INSTALLED = "/application/mark-installed";
const GET_APPLICATION_INSTALL_STATUS = "/application/install-status";
const RESET_APPLICATION_INSTALLED = "/application/reset-installed";

export {
    CREATE_APPLICATION,
    UPLOAD_APPLICATION_LOGO,
    GET_DRIVER_APPLICATION,
    GET_USER_APPLICATION,
    UPDATE_APPLICATION,
    MARK_APPLICATION_INSTALLED,
    GET_APPLICATION_INSTALL_STATUS,
    RESET_APPLICATION_INSTALLED
};
